// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jf-0";
export var fileCarousel = "_jf-2";
export var removeFileButton = "_jf-1";